import axios from 'axios';
import React, { useState, useEffect } from 'react';

import { API_CASINO_ACCOUNT_ACTIVE_BALANCE } from '../../../crm/casino/pages/Helpers/SiteApiUrls';
import useOnce from '../../../crm/hooks/useOnce';
import Loader from '../../loader/Loader';
import { useTranslation } from 'react-i18next';

function AuthorizedPanelSocialCasino({ user: initialUser, links, loading }) {
    const [user, setUser] = useState(initialUser);
    const [activeBalance, setActiveBalance] = useState(initialUser?.casino_active_balance || 'fun');
    const [balanceWasSet, setBalanceWasSet] = useState(false);
    const [shouldReload, setShouldReload] = useState(false);
    const { t } = useTranslation();

    useOnce(() => {
        setShouldReload(document.getElementById('shouldReloadPage')?.value === 'true');
    });

    useEffect(() => {
        setUser(initialUser); // Bypass, two first changes is null
    }, [initialUser]);

    useEffect(() => {
        if (!user) {
            return;
        }
        const channel = window.Echo.private(`balance.${user.token}`);

        const listener = (event) => {
            setUser((prevUser) => ({ ...prevUser, ...event.userData }));
        };

        channel.listen('.casino-balance.updated', listener);

        return () => {
            channel.stopListening('.balance.updated', listener);
        };
    }, [user?.token]);

    useEffect(() => {
        if (!user) {
            return;
        }

        setActiveBalance((prevBalance) => (balanceWasSet ? prevBalance : user.casino_active_balance || 'fun'));
        setBalanceWasSet(true);
    }, [user?.casino_active_balance]);

    const handleBalanceChange = (balanceType) => {
        axios
            .post(API_CASINO_ACCOUNT_ACTIVE_BALANCE, { balanceType })
            .then(() => {
                setActiveBalance(balanceType);
                if (shouldReload) {
                    window.location.reload();
                }
            })
            .catch((error) => {
                console.error('Error changing balance:', error);
            });
    };

    function getBalancesDropdown() {
        if (!user) {
            return <div>{t('userPanel.error')}</div>;
        }
        return (
            <div className="row">
                <div className="col-md-5 col-6">
                    <button
                        type="button"
                        className={`btn balance-top balance-fun ${activeBalance === 'fun' ? 'active' : ''}`}
                        onClick={() => handleBalanceChange('fun')}
                    >
                        {user?.fun_balance?.formatted}
                    </button>
                </div>
                <div className="col-md-5 col-6">
                    <button
                        type="button"
                        className={`btn balance-top balance-social ${activeBalance === 'social' ? 'active' : ''}`}
                        onClick={() => handleBalanceChange('social')}
                    >
                        <div>
                            {user?.social_balance?.formatted}{' '}
                            <span className="balance-win">WIN: {user?.win_balance?.formatted}</span>
                        </div>
                    </button>
                </div>
                <div key="deposit" className="col-2 d-md-flex d-none align-items-center justify-content-center">
                    <a className="btn btn-sm btn-header-deposit" href={links.deposit}>
                        {t('userPanel.buyItem', { item: 'GC' })}
                    </a>
                </div>
            </div>
        );
    }

    const renderBaseContent = () => (
        <>
            <Loader isLoading={loading} elementToShow={getBalancesDropdown()} />
        </>
    );
    return <>{renderBaseContent()}</>;
}

export default AuthorizedPanelSocialCasino;
